import React from 'react';
import {ProductProps} from '../interfaces';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
} from '@material-ui/core';

function Details(props: ProductProps) {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        padding: '0 20px 0 20px',
        '@media (max-width: 768px)': {
          padding: '0',
        },
        '& .icon, & h4.property': {
          color: '#8a8a8a',
        },
        '& .MuiDivider-root': {
          margin: '24px 0',
          color: '#d8d8d8',
        },
        '& h4': {
          margin: 0,
          padding: '0 8px',
        },
      },
      item: {
        marginBottom: '24px',
        display: 'flex',
        alignSelf: 'center',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: 500,
      },
      label: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: 400,
        color: '#8A8A8A',
        marginRight: 'auto',
      },
      typographyCards: {
        fontSize: '16px',
        color: 'white',
        backgroundColor: '#4BCF90',
        paddingTop: '8px',
        paddingRight: '24px',
        paddingBottom: '8px',
        paddingLeft: '50px',
        marginLeft: '-40px',
      },
      cardContent: {
        paddingLeft: '14px',
      },
      card: {
        marginBottom: '14px',
        overflow: 'visible',
        padding: '14px',
      },
    })
  );

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid item lg={12} md={12} spacing={2}>
        <Card className={classes.card}>
          <CardHeader
            avatar={
              <Typography className={classes.typographyCards}>
                اطلاعات کلی کالا
              </Typography>
            }
          />
          <CardContent style={{paddingBottom: '0'}}>
            <Grid item xs={12} sm={12} lg={12} spacing={2}>
              <div className={classes.item}>
                <span className={classes.label}>{'نام کالا:  '}</span>
                <span data-cy="name">{props.product.name}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} spacing={2}>
              <div className={classes.item}>
                <span className={classes.label}>{'کد کالا:  '}</span>
                <span data-cy="id">{props.product.id}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>{'دسته بندی:  '}</span>

                <span data-cy="categoryName">{props.product.categoryName}</span>
              </div>
            </Grid>
            {props.product.description && (
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}>{'توضیحات:  '}</span>

                  <span data-cy="description">{props.product.description}</span>
                </div>
              </Grid>
            )}
          </CardContent>
        </Card>
        <Card className={classes.card}>
          <CardHeader
            avatar={
              <Typography className={classes.typographyCards}>
                اطلاعات وزن و حجم کالا
              </Typography>
            }
          />
          <CardContent style={{paddingBottom: '0'}}>
            <Grid xs={12} sm={12} lg={12} spacing={2}>
              <div className={classes.item}>
                <span className={classes.label}>{' واحد:  '}</span>

                <span data-cy="unit">{props.product.unit}</span>
              </div>
            </Grid>
            <Grid xs={12} sm={12} lg={12} spacing={2}>
              <div className={classes.item}>
                <span className={classes.label}>{' وزن (گرم):  '}</span>

                <span data-cy="weight">{props.product.weight}</span>
              </div>
            </Grid>
            <Grid xs={12} sm={12} lg={12} spacing={2}>
              <div className={classes.item}>
                <span className={classes.label}>{' ابعاد (سانتی متر):  '}</span>

                <Typography
                  style={{direction: 'ltr'}}
                >{`${props.product.width} x ${props.product.height} x ${props.product.length}`}</Typography>
              </div>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}

export default Details;
